import { useState } from 'react'
import { Modal } from 'react-bootstrap'

import uploadIcon from '../../../imgs/upload.png'
import UploadFileOffice from '../UploadFileOffice'

export function UploadFileOfficeModal(props) {
  const [show, setShow] = useState(false)
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const { itemId, useForceUpdate } = props

  const ModalForceUpdate = () => {
    useForceUpdate()
    handleClose()
  }

  return (
    <div>
      <img src={uploadIcon} onClick={handleShow} height='30px' style={{ cursor: 'pointer' }} />

      <Modal size='sm' show={show} onHide={handleClose}>
        <Modal.Header closeButton></Modal.Header>

        <Modal.Body>
          <UploadFileOffice useForceUpdate={ModalForceUpdate} itemId={itemId} />
        </Modal.Body>
      </Modal>
    </div>
  )
}
